import styled, { css } from 'styled-components';

import { Row, Col } from 'Common/Components/Grid';
import { Box } from 'Screens/Contextualization/Dashboard/components/ToolbarItems/Common/Box/styled';

export const EditModeBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 6px 0 10px;
`;

export const AddWidgetButton = styled.button`
  height: 30px;
  padding: 0 14px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  background: transparent;
  border: 1px dashed ${({ theme }) => theme.borders.dashboard};
  color: ${({ theme }) => theme.text.dashboardLightText};
  letter-spacing: 0.3px;

  &:hover {
    border-color: ${({ theme }) => theme.borders.workspaceSelectedItem};
    color: ${({ theme }) => theme.borders.workspaceSelectedItem};
  }
`;

export const EditModeButton = styled.button`
  height: 30px;
  padding: 0 14px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  letter-spacing: 0.3px;

  ${({ $active, theme }) =>
    $active
      ? css`
          background: ${theme.borders.workspaceSelectedItem};
          border: solid 1px ${theme.borders.workspaceSelectedItem};
          color: #fff;
        `
      : css`
          background: transparent;
          border: solid 1px ${theme.borders.dashboard};
          color: ${theme.text.dashboardDarkText};

          &:hover {
            border-color: ${theme.borders.workspaceSelectedItem};
            color: ${theme.text.dashboardTitle};
          }
        `}
`;

export const StyledRow = styled(Row)`
  flex-direction: ${(props) => (props.direction ? `${props.direction}` : 'auto')};
  ${({ marginBottom }) => marginBottom && `
    & > *:not(:last-child) {
      margin-bottom: 14px;
    }
  `}
  ${({ marginRight }) => marginRight && `
    & > *:not(:last-child) {
      margin-right: 7px;
    }
  `}
`;
StyledRow.displayName = 'StyledRow';

export const StyledCol = styled(Col)`
  ${({ marginBottom }) => marginBottom && `
    & > *:not(:last-child) {
      margin-bottom: 14px;
    }
  `}
  ${({ marginRight }) => marginRight && `
    & > *:not(:last-child) {
      margin-right: 7px;
    }
  `}
`;
StyledCol.displayName = 'StyledCol';

export const BoxLatestVulns = styled.div`
  border-radius: 3px;
  border: solid 1px ${({ theme }) => theme.borders.dashboard};
  box-shadow: 0 0 20px 0 ${({ theme }) => theme.shadows.dashboard};
  padding: 22px;
  text-align: left;
  height: 100%;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-top: 0;
  background: ${({ theme }) => theme.backgrounds.dashboardItem};
`;
BoxLatestVulns.displayName = 'BoxLatestVulns';

export const BoxSummary = styled(Box)`
  background-color: ${({ theme }) => theme.backgrounds.vulnSummary};
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom: 0;
`;
BoxSummary.displayName = 'BoxSummary';

export const SummaryStyledCol = styled(StyledCol)`
  margin-bottom: 0px !important;
`;
SummaryStyledCol.displayName = 'SummaryStyledCol';
